import React from "react";
import { Dropdown } from "../common/components/dropdown/Dropdown";
import { USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV } from "../common/roles/constants";
import useRolesVisibility from "../common/roles/useRolesVisibility";
import { RequiredRoles } from "../search/criteria/components/common/requiredRoles";
import useItemsPerPage from "./useItemsPerPage";
import useModal from "../common/components/modals/useModal";

export function ItemsPerPageDropdown() {
	const { clearModals } = useModal();
	const { onPageSizeSelected, pageSize } = useItemsPerPage();
	const { hasOneOfRequiredRoles } = useRolesVisibility(
		RequiredRoles.showFor([USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV]),
	);

	const handleDropdownItemClick = (input) => {
		onPageSizeSelected(input);
		clearModals();
	};

	const dropdownItems = [
		{ key: "15", value: "15" },
		{ key: "25", value: "25" },
		{ key: "50", value: "50" },
		{ key: "100", value: "100" },
	];

	if (!hasOneOfRequiredRoles) {
		return null;
	}

	return (
		<div className="actions__action align-center">
			<div className="flex info--text">
				<p>Articles per page</p>

				<Dropdown
					additionalClasses={{
						dropdown: "dropdown--light dropdown--right",
					}}
					dropdownToggle={pageSize}
					dropdownItems={dropdownItems}
					dropdownKey="itemsPerPageDropdown"
					onDropdownItemClick={handleDropdownItemClick}
				/>
			</div>
		</div>
	);
}
